<template>
  <Modal title="" :max-width="600" :header-border="false" body-overflow="auto" body-max-height="500px" :body-padding="false" @close="onClose">
    <template #header>
      <div class="cd__title-wrap">
        <span class="cd-source">
          <span class="cd-source__mark" style="background: #0d9dda; color: #fff;">
            <svg viewBox="0 0 16 16" fill="currentColor"><path d="M6.5 4.2a3 3 0 015.4 1 2.4 2.4 0 011.6 4.3 2.6 2.6 0 01-3 2 3.1 3.1 0 01-5.2-.4 2.3 2.3 0 01-2-3.9 2.7 2.7 0 013.2-3z"/></svg>
          </span>
          Salesforce
        </span>
        <div class="cd__name">{{ campaignName }}</div>
        <div class="cd__sub">
          <span>Campaign Member</span>
          <span v-if="data.status" class="cd__dot" />
          <span v-if="data.status">{{ data.status }}</span>
        </div>
      </div>
    </template>

    <div class="cm-body">
      <div class="cd-notes">
        <div class="cd-note">
          <span class="cd-note__k">Contact</span>
          <span class="cd-note__v">{{ data.contact_name || data.contact_email || '—' }}</span>
        </div>
        <div v-if="data.contact_email && data.contact_name" class="cd-note">
          <span class="cd-note__k">Email</span>
          <span class="cd-note__v">{{ data.contact_email }}</span>
        </div>
        <div class="cd-note">
          <span class="cd-note__k">Status</span>
          <span class="cd-note__v">{{ data.status || '—' }}</span>
        </div>
        <div v-if="data.created_date" class="cd-note">
          <span class="cd-note__k">Added</span>
          <span class="cd-note__v">{{ formatDate(data.created_date) }}</span>
        </div>
        <div v-if="data.first_responded_date" class="cd-note">
          <span class="cd-note__k">Responded</span>
          <span class="cd-note__v">{{ formatDate(data.first_responded_date) }}</span>
        </div>
      </div>
    </div>

    <template #footer>
      <button class="cd-btn cd-btn--ghost" @click="onClose">Close</button>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import Modal from '../../next/components/Modal.vue'

const props = defineProps<{
  item: Record<string, any>
  onClose: () => void
}>()

const data = computed(() => props.item?.data || {})
const campaignName = computed(() => String(data.value.campaign_name || 'Campaign').trim() || 'Campaign')

function formatDate(value: any): string {
  if (!value) return '—'
  try {
    return new Date(value).toLocaleString([], { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit' })
  } catch {
    return String(value)
  }
}
</script>

<style scoped>
.cm-body {
  padding: var(--space-5);
}
</style>
